import React, { useState } from 'react';
import { Turl } from '../components/tUrl.js';
import '../css/emailVerificationFlow.css'; // Используем те же стили
import { t } from 'ttag';
import { formatNumberWithCommas } from '../components/formatIntegerWithCommas.js';

const tg = window.Telegram ? window.Telegram.WebApp : null;

// --- API Функции ---


const sendWithdrawCode = async (address, amount) => {
    const _userData = tg ? tg.initData : null;
    let userData = {
        initData: _userData,
        amount: parseFloat(amount),
        address: address,
        type: 4 
    }

    const response = await fetch(Turl + '/st/send-trade-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userData),
    });
    return response.json();
};


const submitWithdraw = async (address, amount, code) => {
    const _userData = tg ? tg.initData : null;
    let userData = {
        initData: _userData,
        code: code,
        amount: parseFloat(amount),
        address: address
    };

    const response = await fetch(Turl + '/st/submit-withdraw', { 
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
    });
    return response.json();
};

// --- Компонент ---

const WithdrawBEP20 = ({ recData }) => {
    const [step, setStep] = useState('enter_details'); // 'enter_details', 'enter_code', 'confirmed'
    
    const [address, setAddress] = useState('');
    const [amount, setAmount] = useState('');

    const [code, setCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const bep20Regex = /^0x[a-fA-F0-9]{40}$/;

    // ‼️ Обработчик для Шага 1: Ввод адреса и суммы
    const handleDetailsSubmit = async (e) => {
        e.preventDefault();
        
        // --- Клиентская валидация ---
        if (!bep20Regex.test(address)) {
            setError(t`Invalid BEP-20 address. It must start with 0x and be 42 characters long.`);
            return;
        }
        if (parseFloat(amount) <= 1) {
            setError(t`Amount must be greater than 1.`);
            return;
        }
        if (parseFloat(amount) > recData.usdt) {
            setError(t`Not enough funds on balance.`);
            return;
        }
        // --- Конец Валидации ---

        setIsLoading(true);
        setError('');

        const response = await sendWithdrawCode(address, amount);

        setIsLoading(false);
        if (response.success) {
            setStep('enter_code'); // Переходим к шагу ввода кода
        } else {
            setError(response.message || 'Failed to send code. Please try again.');
        }
    };

    // ‼️ Обработчик для Шага 2: Ввод кода
    const handleCodeSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        const response = await submitWithdraw(address, amount, code);

        setIsLoading(false);
        if (response.success) {
            setStep('confirmed');
            setTimeout(() => {
                window.location.reload(); // Обновляем страницу после успеха
            }, 1500); // 1.5 секунды, чтобы пользователь успел прочитать
        } else {
            setError(response.message || 'Error. Invalid code or amount.');
        }
    };

    // --- Рендеринг в зависимости от текущего шага ---

    if (step === 'confirmed') {
        return (
            <div className="Email-block">
                <div>
                    <h2 style={{ color: '#4cdf4c' }}>✓ {t`Successfully!`}</h2>
                    <p>
                        {t`Your withdrawal of`} <strong>{amount} USDT</strong> {t`to the address`} <br/>
                        <strong>{address}</strong> {t`is being processed.`}
                    </p>
                </div>
            </div>
        );
    }

    if (step === 'enter_code') {
        return (
            <div className="Email-block">
                <h2>{t`Email Confirmation`}</h2>
                <p>
                    {t`We sent a code to your registered email.`}<br />
                    {t`You are withdrawing`} <strong>{amount} USDT</strong> {t`to address:`}
                    <br/>
                    <strong style={{fontSize: '12px', wordBreak: 'break-all'}}>{address}</strong>
                </p>
                <form onSubmit={handleCodeSubmit}>
                    <div className='email-enter'>
                        <label htmlFor="code">{t`Verification code:`}</label>
                        <input
                            type="text"
                            id="code"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            placeholder="123456"
                            required
                            disabled={isLoading}
                        />
                    </div>
                    <div className='email-enter'>
                        <button type="submit" disabled={isLoading || code.length < 6}>
                            {isLoading ? t`Checking...` : t`Confirm & Withdraw`}
                        </button>
                    </div>
                    {error && <p className="error-text">{error}</p>}
                    <button
                        type="button"
                        onClick={() => { setStep('enter_details'); setError(''); }}
                        className="link-button"
                    >
                        {t`Change details`}
                    </button>
                </form>
            </div>
        );
    }

    // --- Шаг 1: Ввод деталей вывода ---
    return (
        <>
            {/* Блок Баланса */}
            <div className="f-balance-card">
                <div className="f-balance-label">{t`Balance`}</div>
                <div className="f-balance-value">{formatNumberWithCommas(parseFloat(recData.usdt), 4)} USDT</div>
            </div>

            <div className="Email-block">
                <h2>{t`Withdraw to BEP-20 (BSC)`}</h2>
                <p>{t`Funds will be sent to the specified address after email confirmation.`}</p>
                <form onSubmit={handleDetailsSubmit}>

                    <div className='email-enter'>
                        <label htmlFor="address">{t`BEP-20 Address:`}</label>
                        <input
                            type="text"
                            id="address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            placeholder="0x..."
                            required
                            disabled={isLoading}
                        />
                    </div>

                    <div className='email-enter'>
                        <label htmlFor="amount">{t`Amount:`}</label>
                        <div className="input-with-button"> {/* Обертка для кнопки "Max" */}
                            <input
                                type="number"
                                id="amount"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                placeholder="100.00"
                                required
                                disabled={isLoading}
                                style={{width: '100%'}} // Инпут занимает всю ширину обертки
                            />
                            {/* Кнопка "Max" */}
                            <button
                                type="button"
                                className="max-button" // Добавьте стили для .max-button
                                onClick={() => setAmount(recData.usdt)}
                                disabled={isLoading}
                                style={{width: '30%'}} // Инпут занимает всю ширину обертки
                            >
                                MAX
                            </button>
                        </div>
                    </div>

                    <div className='email-enter'>
                        <button
                            type="submit"
                            disabled={isLoading || !amount || !address || parseFloat(amount) <= 0}
                        >
                            {isLoading ? t`Sending...` : t`Send code`}
                        </button>
                    </div>
                    {error && <p className="error-text">{error}</p>}
                </form>
            </div>
        </>
    );
};

export { WithdrawBEP20 };